export const maintenancePageTranslations = {
  title: 'Maintenance en cours',
  message:
    'Nous effectuons actuellement une maintenance afin d’améliorer votre expérience. Merci de votre patience.',
};
